import './VinylCard.css'

interface VinylCardProps {
    name: string;
    image: string;
    onSelect?: () => void;
    isSelected: boolean;
}


export const VinylCard = (props: VinylCardProps) => {

    const getImage = (image: string) => {
        let imageElement;
        
        switch (image) {
            case "square":
                imageElement = (
                    <div className="vinyl-card-shape-wrapper">
                        <div className='vinyl-card-shape square'></div>
                    </div>
                )
                break;
            case "circle":
                imageElement = (
                    <div className="vinyl-card-shape-wrapper">
                        <div className='vinyl-card-shape circle'></div>
                    </div>
                )
                break;
            case "triangle":
                imageElement = (
                    <div className="vinyl-card-shape-wrapper">
                        <div className='vinyl-card-shape triangle'></div>
                    </div>
                )
                break;
            default:
                imageElement = <img 
                    className="vinyl-card-image" 
                    style={{fill: '#000'}}
                    width={64}
                    height={64} 
                    src={`/icons/64px/${image}.svg`} 
                />;
                break;
        }

        return imageElement;
    }

    return (
        <div className={`vinyl-card ${props.isSelected ? 'selected' : ''}`} onClick={props.onSelect}>
            <div className={`vinyl-card-content ${props.isSelected ? 'selected' : ''}`}>
                <div className="vinyl-card-content-header">
                    <h1 className="vinyl-card-name">{props.name}</h1>
                </div>
                <div className="vinyl-card-content-body">
                    {getImage(props.image)}
                </div>
                <div></div>
            </div>
        </div>
    )
}
